import { render, staticRenderFns } from "./DetailCommande.vue?vue&type=template&id=1a75241b&"
import script from "./DetailCommande.vue?vue&type=script&lang=js&"
export * from "./DetailCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports